import { Controller } from "@hotwired/stimulus"

import "jquery" // jQuery (1.11.3)
import "@accessible360/accessible-slick/slick/slick.min.css"
import "@accessible360/accessible-slick/slick/accessible-slick-theme.min.css"
import "@accessible360/accessible-slick"
import "@assets/stylesheets/slick.scss"

// Connects to data-controller="sliders--carousel"
export default class extends Controller {
  static targets = ["slides", "nextArrow", "prevArrow"]
  static values = {
    options: { type: Object, default: {} },
  }

  connect() {
    $(this.slidesTarget).slick({
      ...this.defaultOptions,
      ...this.optionsValue,
      ...this.slideArrows,
    })
  }

  disconnect() {
    $(this.slidesTarget).slick("unslick")
  }

  get slideArrows() {
    return this.optionsValue.arrows
      ? {
          prevArrow: this.prevArrowTarget,
          nextArrow: this.nextArrowTarget,
        }
      : {}
  }

  get defaultOptions() {
    return {
      dots: true,
      arrows: false,
    }
  }
}
